import React from 'react';
import Logout from '../common/logout';
import SalesUserLogout from '../salesUser/common/Logout';


//Afetr User login Header
const Header=() =>{

    const capitalize = (str) => {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
    }

    return(
        <div className="dash_header_wrapper">
            <div className="dash_header_left">
                <span>Welcome,</span>
                <span> {JSON.parse(localStorage.getItem('userInfo')) && capitalize(JSON.parse(localStorage.getItem('userInfo')).name)}</span>
                {/* <span> {JSON.parse(localStorage.getItem('salesUserInfo')) && capitalize(JSON.parse(localStorage.getItem('salesUserInfo')).name)}</span> */}
            </div>
            {JSON.parse(localStorage.getItem('userInfo')) && <Logout />}
            {/* {JSON.parse(localStorage.getItem('salesUserInfo')) && <SalesUserLogout/>} */}
        </div>
    )
}
export default Header;


// WEBPACK FOOTER //
// ./web/components/common/HeaderAfterLogin.js